'use strict';

angular.module('app.exposureReportKPI', [])
    .directive('exposureReportKpiDirective', function () {
        return {
            controller: 'exposureReportKPICtrl',
            templateUrl: 'app/measure/exposureReport/exposureReportKPI/exposureReportKPI.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })